import { render, staticRenderFns } from "./UmDbDeckList.vue?vue&type=template&id=c4837ee4&"
import script from "./UmDbDeckList.vue?vue&type=script&lang=js&"
export * from "./UmDbDeckList.vue?vue&type=script&lang=js&"
import style0 from "./UmDbDeckList.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports